<template>
  <Modal
    open
    :title="$t('save-as-draft-modal.title')"
    @update:open="(value) => !value && emit('cancel')"
  >
    <template #footer>
      <Button :label="$t('common.save')" @click="emit('submit')" />
      <Button
        :label="$t('common.no-thanks')"
        :variant="ButtonVariant.OUTLINED"
        @click="emit('close')"
      />
      <Button
        :label="$t('common.cancel')"
        :variant="ButtonVariant.TEXT"
        :color="ButtonColor.SECONDARY"
        @click="emit('cancel')"
      />
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { Button, ButtonColor, ButtonVariant, Modal } from '@exfluential/ui';

const emit = defineEmits<{
  close: [];
  cancel: [];
  submit: [];
}>();
</script>
